import type { LocaleMessageBundle } from '../../types'

export const systemSettingMessages: LocaleMessageBundle = {
  vi: {
    'setting.system.title': 'Cấu hình hệ thống',
    'setting.system.subtitle': 'Thương hiệu, giao diện, email, chuyển khoản và chính sách bán hàng',
    'setting.system.tabs.branding': 'Thương hiệu',
    'setting.system.tabs.appearance': 'Giao diện',
    'setting.system.tabs.locale': 'Ngôn ngữ & định dạng',
    'setting.system.tabs.email': 'Email (SMTP)',
    'setting.system.tabs.birthdayEmail': 'Email sinh nhật',
    'setting.system.tabs.bank': 'Chuyển khoản',
    'setting.system.tabs.sales': 'Bán hàng',
    'setting.system.tabs.invoice': 'Hóa đơn',
    'setting.system.tabs.attendance': 'Cấu hình chấm công',
    'setting.system.tabs.payrollApproval': 'Quy trình duyệt lương',
    'setting.system.payrollApproval.intro': 'Chọn các bước xác nhận phiếu lương trước khi thanh toán.',
    'setting.system.payrollApproval.workflow': 'Mẫu quy trình',
    'setting.system.payrollApproval.managerFinalDescription': 'Quản lý gửi phiếu → Nhân viên xác nhận hoặc yêu cầu sửa → Quản lý xác nhận cuối → Thanh toán.',
    'setting.system.payrollApproval.employeeFinalDescription': 'Quản lý gửi phiếu → Nhân viên xác nhận hoặc yêu cầu sửa → Thanh toán; không có bước quản lý xác nhận cuối.',
    'setting.system.payrollApproval.effectiveHint': 'Thay đổi chỉ áp dụng cho các phiếu được gửi lần đầu sau khi lưu. Phiếu đã gửi tiếp tục dùng quy trình cũ.',
    'setting.system.payrollApproval.notConfigured': 'Chưa chọn quy trình duyệt lương. Cần lưu một mẫu trước khi gửi phiếu cho nhân viên.',
    'setting.system.payrollApproval.saved': 'Đã lưu quy trình duyệt lương.',
    'setting.system.tabs.qrOrder': 'QR Order',
    'setting.system.faceDevice.title': 'Thiết bị nhận diện khuôn mặt',
    'setting.system.faceDevice.refreshHint':
      'Dữ liệu không tự động cập nhật. Bấm Làm mới hoặc F5 để xem trạng thái mới nhất.',
    'setting.system.faceDevice.branch': 'Chi nhánh sử dụng thiết bị',
    'setting.system.faceDevice.name': 'Tên thiết bị',
    'setting.system.faceDevice.code': 'Mã thiết bị',
    'setting.system.faceDevice.serial': 'Serial number (SN)',
    'setting.system.faceDevice.cpuSerial': 'CPU serial',
    'setting.system.faceDevice.cpuSerialHint':
      'CPU serial chỉ dùng để xác thực khi provision và không được hiển thị lại.',
    'setting.system.faceDevice.cpuSerialSavedHint':
      'Đã lưu {maskedSerial}. Để trống để giữ nguyên, hoặc nhập giá trị mới để thay đổi.',
    'setting.system.faceDevice.transferExisting': 'Chuyển thiết bị này từ tenant khác',
    'setting.system.faceDevice.transferExistingWarning':
      'CPU serial phải khớp. Thiết bị ở tenant cũ sẽ bị ngừng và chuyển sang tenant hiện tại.',
    'setting.system.faceDevice.timezone': 'Múi giờ thiết bị',
    'setting.system.faceDevice.lastSeen': 'Kết nối gần nhất',
    'setting.system.faceDevice.neverConnected': 'Chưa kết nối',
    'setting.system.faceDevice.status.active': 'Đang hoạt động',
    'setting.system.faceDevice.status.locked': 'Khóa',
    'setting.system.faceDevice.provision': 'Lưu',
    'setting.system.faceDevice.saved': 'Đã lưu cấu hình thiết bị FaceID',
    'setting.system.faceDevice.add': 'Thêm thiết bị',
    'setting.system.faceDevice.edit': 'Sửa thiết bị',
    'setting.system.faceDevice.disable': 'Ngừng thiết bị',
    'setting.system.faceDevice.disabled': 'Đã ngừng thiết bị FaceID',
    'setting.system.faceDevice.release': 'Gỡ thiết bị',
    'setting.system.faceDevice.released': 'Đã gỡ thiết bị khỏi tenant',
    'setting.system.faceDevice.releaseConfirm':
      'Gỡ thiết bị {name} khỏi tenant? Serial sẽ được giải phóng để đăng ký ở tenant khác. Lịch sử chấm công vẫn được giữ lại.',
    'setting.system.faceDevice.disableConfirm':
      'Ngừng thiết bị {name}? Nhân viên sẽ không còn được đồng bộ tới thiết bị này.',
    'setting.system.qrOrder.tenant': 'Mã tenant',
    'setting.system.qrOrder.branch': 'Chi nhánh',
    'setting.system.qrOrder.tables': 'Bàn',
    'setting.system.qrOrder.allTables': 'Tất cả bàn',
    'setting.system.qrOrder.selectedTables': 'Chọn bàn',
    'setting.system.qrOrder.generate': 'Tạo mã QR',
    'setting.system.qrOrder.download': 'Tải xuống',
    'setting.system.fields.displayName': 'Tên hiển thị',
    'setting.system.fields.logo': 'Logo',
    'setting.system.fields.favicon': 'Favicon',
    'setting.system.fields.primaryColor': 'Màu chủ đạo',
    'setting.system.fields.defaultLocale': 'Ngôn ngữ mặc định',
    'setting.system.fields.dateFormat': 'Định dạng ngày',
    'setting.system.fields.timeFormat': 'Định dạng giờ',
    'setting.system.fields.smtpHost': 'SMTP host',
    'setting.system.fields.smtpPort': 'SMTP port',
    'setting.system.fields.smtpEncryption': 'Mã hóa',
    'setting.system.fields.smtpUsername': 'Tên đăng nhập',
    'setting.system.fields.smtpPassword': 'Mật khẩu',
    'setting.system.fields.smtpFromEmail': 'Email gửi đi',
    'setting.system.fields.smtpFromName': 'Tên người gửi',
    'setting.system.fields.reportRecipientEmails': 'Email nhận báo cáo mặc định',
    'setting.system.fields.allowNegativeStock': 'Cho phép bán khi âm tồn kho',
    'setting.system.fields.allowEditPrice': 'Cho phép sửa giá khi bán',
    'setting.system.fields.requireCustomer': 'Bắt buộc chọn khách hàng',
    'setting.system.fields.allowLineDiscount': 'Cho phép giảm giá theo dòng',
    'setting.system.fields.allowInvoiceDiscount': 'Cho phép giảm giá hóa đơn',
    'setting.system.fields.autoSelectSingleProduct':
      'Tự chọn sản phẩm khi tìm thấy đúng một kết quả',
    'setting.system.fields.maxPlayersPerTable': 'Giới hạn số lượng người chơi',
    'setting.system.fields.kitchenEnabled': 'Bật bếp',
    'setting.system.fields.locationManagementEnabled': 'Bật quản lý vị trí sản phẩm',
    'setting.system.fields.tableOrderEnabled': 'Bán đặt hàng theo bàn',
    'setting.system.hints.tableOrderEnabled':
      'Khi bật, khách quét QR bàn có thể gọi món trên webview; lễ tân phải nhập lý do khi trừ món đã chốt khỏi hóa đơn.',
    'setting.system.fields.saleGridEnabled': 'Bán thường dạng lưới',
    'setting.system.hints.saleGridEnabled':
      'Khi bật, màn "Bán thường" hiển thị lưới sản phẩm theo danh mục thay cho danh sách dòng hàng.',
    'setting.system.hints.locationManagementEnabled':
      'Cho phép quản lý tồn kho theo vị trí thuộc từng chi nhánh. Việc chọn vị trí trên chứng từ vẫn không bắt buộc.',
    'setting.system.fields.requireLocationOnSale': 'Bắt buộc chọn vị trí khi bán hàng',
    'setting.system.hints.requireLocationOnSale':
      'Khi bật, nhân viên phải chọn vị trí xuất hàng cho từng sản phẩm có theo dõi tồn kho trên màn Bán thường. Khi tắt, hệ thống tự phân bổ vị trí xuất theo tồn kho hiện có.',
    'setting.system.hints.autoSelectSingleProduct':
      'Khi bật, ô tìm sản phẩm sẽ tự thêm sản phẩm nếu kết quả tìm kiếm chỉ có một sản phẩm.',
    'setting.system.fields.allowViewCancelledInvoices': 'Cho phép xem hóa đơn đã hủy',
    'setting.system.hints.allowViewCancelledInvoices':
      'Khi tắt, danh sách hóa đơn sẽ ẩn hóa đơn đã hủy, không thể lọc hoặc mở chi tiết hóa đơn đã hủy.',
    'setting.system.fields.bankName': 'Ngân hàng',
    'setting.system.fields.bankBin': 'VietQR BIN',
    'setting.system.fields.accountNumber': 'Số tài khoản',
    'setting.system.fields.accountHolder': 'Chủ tài khoản',
    'setting.system.fields.bankBranchName': 'Chi nhánh ngân hàng',
    'setting.system.fields.isDefault': 'Mặc định',
    'setting.system.fields.isActive': 'Trạng thái',
    'setting.system.fields.note': 'Ghi chú',
    'setting.system.fields.sortOrder': 'Thứ tự',
    'setting.system.actions.save': 'Lưu thay đổi',
    'setting.system.actions.testSmtp': 'Gửi email thử',
    'setting.system.actions.uploadLogo': 'Tải logo',
    'setting.system.actions.uploadFavicon': 'Tải favicon',
    'setting.system.actions.removeLogo': 'Xóa logo',
    'setting.system.actions.removeFavicon': 'Xóa favicon',
    'setting.system.actions.addBankAccount': 'Thêm tài khoản',
    'setting.system.actions.editBankAccount': 'Sửa tài khoản',
    'setting.system.bank.deleteConfirm': 'Bạn có chắc muốn xóa tài khoản {name} ({number})?',
    'setting.system.hints.smtpPasswordKeep': 'Để trống nếu giữ mật khẩu hiện tại',
    'setting.system.hints.smtpPasswordSaved': 'Mật khẩu đã được lưu. Để trống nếu không thay đổi.',
    'setting.system.hints.reportRecipientEmails':
      'Nhập tối đa 10 địa chỉ email, nhấn Enter sau mỗi địa chỉ.',
    'setting.system.hints.timezoneFixed': 'Múi giờ hệ thống: Asia/Ho_Chi_Minh',
    'setting.system.birthday.intro':
      'Hệ thống tự động gửi email chúc mừng sinh nhật vào giờ đã cấu hình, dựa trên ngày sinh của khách hàng và nhân viên.',
    'setting.system.birthday.general': 'Cấu hình chung',
    'setting.system.birthday.sendHour': 'Giờ gửi hằng ngày',
    'setting.system.birthday.allowCatchUp': 'Cho phép gửi bù trong ngày',
    'setting.system.birthday.allowCatchUpHint':
      'Khi tắt, hệ thống chỉ gửi trong khung giờ đã cấu hình và không gửi bù các email của ngày đã qua.',
    'setting.system.birthday.customerTemplate': 'Mẫu email cho khách hàng',
    'setting.system.birthday.staffTemplate': 'Mẫu email cho nhân viên',
    'setting.system.birthday.customerEnabled': 'Gửi email sinh nhật cho khách hàng',
    'setting.system.birthday.staffEnabled': 'Gửi email sinh nhật cho nhân viên',
    'setting.system.birthday.subject': 'Tiêu đề email',
    'setting.system.birthday.body': 'Nội dung email',
    'setting.system.birthday.variables':
      'Biến hỗ trợ: {name}, {store_name}, {birth_date}, {age}, {year}. Biến có thể viết {name} hoặc {{name}}.',
    'setting.system.birthday.defaultHint':
      'Nội dung sẽ được hiển thị trong mẫu email chuẩn của hệ thống. Chỉ dùng văn bản thuần; HTML sẽ không được hiển thị.',
    'setting.system.birthday.test.title': 'Gửi email sinh nhật thử',
    'setting.system.birthday.test.recipientType': 'Loại nội dung mẫu',
    'setting.system.birthday.test.toEmail': 'Email nhận thử',
    'setting.system.birthday.test.customer': 'Mẫu khách hàng',
    'setting.system.birthday.test.staff': 'Mẫu nhân viên',
    'setting.system.birthday.test.success': 'Đã gửi email sinh nhật thử thành công',
    'setting.system.birthday.actions.test': 'Gửi thử',
    'setting.system.birthday.actions.history': 'Xem lịch sử gửi',
    'setting.system.birthday.history.title': 'Lịch sử gửi email sinh nhật',
    'setting.system.birthday.history.subtitle':
      'Theo dõi trạng thái gửi email và đối chiếu quy tắc chống gửi trùng theo từng năm.',
    'setting.system.birthday.filters.dateFrom': 'Từ ngày',
    'setting.system.birthday.filters.dateTo': 'Đến ngày',
    'setting.system.birthday.filters.dateRange': 'Khoảng ngày gửi',
    'setting.system.birthday.filters.recipientType': 'Đối tượng',
    'setting.system.birthday.filters.status': 'Trạng thái',
    'setting.system.birthday.filters.keyword': 'Tìm theo tên, email hoặc tiêu đề',
    'setting.system.birthday.fields.recipientType': 'Đối tượng',
    'setting.system.birthday.fields.recipient': 'Người nhận',
    'setting.system.birthday.fields.email': 'Email',
    'setting.system.birthday.fields.birthDate': 'Ngày sinh',
    'setting.system.birthday.fields.birthdayYear': 'Năm gửi',
    'setting.system.birthday.fields.subject': 'Tiêu đề',
    'setting.system.birthday.fields.status': 'Trạng thái',
    'setting.system.birthday.fields.attempts': 'Số lần thử',
    'setting.system.birthday.fields.error': 'Lỗi / lý do bỏ qua',
    'setting.system.birthday.fields.sentAt': 'Gửi lúc',
    'setting.system.birthday.fields.createdAt': 'Tạo lúc',
    'setting.system.birthday.recipient.customer': 'Khách hàng',
    'setting.system.birthday.recipient.staff': 'Nhân viên',
    'setting.system.birthday.status.queued': 'Đã xếp hàng',
    'setting.system.birthday.status.sent': 'Đã gửi',
    'setting.system.birthday.status.failed': 'Lỗi gửi',
    'setting.system.birthday.status.skipped': 'Bỏ qua',
    'setting.system.birthday.actions.retry': 'Gửi lại',
    'setting.system.birthday.actions.retryConfirm':
      'Gửi lại email này? Hệ thống chỉ cho phép gửi lại nếu người nhận chưa từng gửi thành công trong năm này.',
    'setting.system.birthday.actions.retrySuccess': 'Đã đưa vào hàng đợi gửi lại',
    'setting.system.birthday.actions.resetTemplate': 'Khôi phục mẫu mặc định',
    'setting.system.birthday.actions.resetTemplateConfirm':
      'Khôi phục mẫu mặc định cho toàn bộ tiêu đề/nội dung khách hàng và nhân viên?',
    'setting.system.birthday.validation.sendHour': 'Chọn giờ gửi hợp lệ (00:00 – 23:59)',
    'setting.system.birthday.validation.subject': 'Tiêu đề email không được để trống',
    'setting.system.birthday.validation.body': 'Nội dung email không được để trống',
    'setting.system.birthday.duplicateHint':
      'Quy tắc chống gửi trùng: mỗi khách hàng hoặc nhân viên chỉ được gửi tối đa 1 email sinh nhật cho mỗi năm.',
    'setting.system.hints.brandingUiOnly':
      'Logo/favicon chỉ áp dụng cho giao diện app (chưa in hóa đơn)',
    'setting.system.hints.maxPlayersPerTable':
      'Số người chơi tối đa được thêm vào một bàn (từ 1 đến 100)',
    'setting.system.hints.kitchenEnabled':
      'Khi bật, chỉ thanh toán khi tất cả món đã hoàn thành hoặc bị hủy',
    'setting.system.hints.bankAutoBin':
      'Gõ tên hoặc mã viết tắt ngân hàng để tự động điền VietQR BIN',
    'setting.system.hints.bankBin': 'VietQR/NAPAS BIN gồm 6 chữ số',
    'setting.system.validation.maxPlayersPerTable':
      'Giới hạn người chơi phải là số nguyên từ 1 đến 100',
    'setting.system.validation.bankBin': 'VietQR BIN phải gồm đúng 6 chữ số',
    'setting.system.smtpTest.title': 'Gửi email thử',
    'setting.system.smtpTest.toEmail': 'Email nhận',
    'setting.system.smtpTest.success': 'Đã gửi email thử thành công',
    'setting.system.success.saved': 'Đã lưu cấu hình hệ thống',
    'setting.system.errors.loadFailed': 'Không tải được cấu hình hệ thống',
    'setting.system.errors.saveFailed': 'Lưu cấu hình hệ thống thất bại',
    'setting.system.errors.brandingUploadFailed': 'Tải lên thương hiệu thất bại',
    'setting.system.errors.brandingDeleteFailed': 'Xóa thương hiệu không thành công.',
    'setting.system.errors.smtpTestFailed': 'Gửi email thử thất bại',
    'setting.system.errors.requireCustomer': 'Vui lòng chọn khách hàng trước khi thanh toán',
    'setting.system.locale.vi': 'Tiếng Việt',
    'setting.system.locale.en': 'English',
    'setting.system.time.24h': '24 giờ',
    'setting.system.time.12h': '12 giờ',
  },
  en: {
    'setting.system.title': 'System settings',
    'setting.system.subtitle': 'Branding, appearance, email, bank transfer and sales policies',
    'setting.system.tabs.branding': 'Branding',
    'setting.system.tabs.appearance': 'Appearance',
    'setting.system.tabs.locale': 'Language & formats',
    'setting.system.tabs.email': 'Email (SMTP)',
    'setting.system.tabs.birthdayEmail': 'Birthday Emails',
    'setting.system.tabs.bank': 'Bank transfer',
    'setting.system.tabs.sales': 'Sales',
    'setting.system.tabs.invoice': 'Invoices',
    'setting.system.tabs.attendance': 'Attendance settings',
    'setting.system.tabs.payrollApproval': 'Payroll approval workflow',
    'setting.system.payrollApproval.intro': 'Choose the payslip confirmation steps required before payment.',
    'setting.system.payrollApproval.workflow': 'Workflow template',
    'setting.system.payrollApproval.managerFinalDescription': 'Manager sends the payslip → Employee confirms or requests changes → Manager gives final approval → Payment.',
    'setting.system.payrollApproval.employeeFinalDescription': 'Manager sends the payslip → Employee confirms or requests changes → Payment, without a final manager approval step.',
    'setting.system.payrollApproval.effectiveHint': 'Changes apply only to payslips sent for the first time after saving. Previously sent payslips keep their workflow.',
    'setting.system.payrollApproval.notConfigured': 'No payroll approval workflow is configured. Save a template before sending payslips to employees.',
    'setting.system.payrollApproval.saved': 'Payroll approval workflow saved.',
    'setting.system.tabs.qrOrder': 'QR Order',
    'setting.system.faceDevice.title': 'Face identification device',
    'setting.system.faceDevice.refreshHint':
      'Data does not update automatically. Refresh or reload the page to see the latest status.',
    'setting.system.faceDevice.branch': 'Device branch',
    'setting.system.faceDevice.name': 'Device name',
    'setting.system.faceDevice.code': 'Device code',
    'setting.system.faceDevice.serial': 'Serial number (SN)',
    'setting.system.faceDevice.cpuSerial': 'CPU serial',
    'setting.system.faceDevice.cpuSerialHint':
      'The CPU serial is only used during provisioning and is never displayed again.',
    'setting.system.faceDevice.cpuSerialSavedHint':
      'Saved as {maskedSerial}. Leave blank to keep it, or enter a new value to change it.',
    'setting.system.faceDevice.transferExisting': 'Transfer this device from another tenant',
    'setting.system.faceDevice.transferExistingWarning':
      'The CPU serial must match. The device will be disabled in the previous tenant and moved to the current tenant.',
    'setting.system.faceDevice.timezone': 'Device timezone',
    'setting.system.faceDevice.lastSeen': 'Last connected',
    'setting.system.faceDevice.neverConnected': 'Never connected',
    'setting.system.faceDevice.status.active': 'Active',
    'setting.system.faceDevice.status.locked': 'Locked',
    'setting.system.faceDevice.provision': 'Save and provision',
    'setting.system.faceDevice.saved': 'FaceID device settings saved',
    'setting.system.faceDevice.add': 'Add device',
    'setting.system.faceDevice.edit': 'Edit device',
    'setting.system.faceDevice.disable': 'Disable device',
    'setting.system.faceDevice.disabled': 'FaceID device disabled',
    'setting.system.faceDevice.release': 'Release device',
    'setting.system.faceDevice.released': 'Device released from tenant',
    'setting.system.faceDevice.releaseConfirm':
      'Release {name} from this tenant? Its serial can then be registered by another tenant. Attendance history will be preserved.',
    'setting.system.faceDevice.disableConfirm':
      'Disable {name}? Staff will no longer be synchronized to this device.',
    'setting.system.qrOrder.tenant': 'Tenant code',
    'setting.system.qrOrder.branch': 'Branch',
    'setting.system.qrOrder.tables': 'Tables',
    'setting.system.qrOrder.allTables': 'All tables',
    'setting.system.qrOrder.selectedTables': 'Select tables',
    'setting.system.qrOrder.generate': 'Generate QR codes',
    'setting.system.qrOrder.download': 'Download',
    'setting.system.fields.displayName': 'Display name',
    'setting.system.fields.logo': 'Logo',
    'setting.system.fields.favicon': 'Favicon',
    'setting.system.fields.primaryColor': 'Primary color',
    'setting.system.fields.defaultLocale': 'Default language',
    'setting.system.fields.dateFormat': 'Date format',
    'setting.system.fields.timeFormat': 'Time format',
    'setting.system.fields.smtpHost': 'SMTP host',
    'setting.system.fields.smtpPort': 'SMTP port',
    'setting.system.fields.smtpEncryption': 'Encryption',
    'setting.system.fields.smtpUsername': 'Username',
    'setting.system.fields.smtpPassword': 'Password',
    'setting.system.fields.smtpFromEmail': 'From email',
    'setting.system.fields.smtpFromName': 'From name',
    'setting.system.fields.reportRecipientEmails': 'Default report recipients',
    'setting.system.fields.allowNegativeStock': 'Allow selling with negative stock',
    'setting.system.fields.allowEditPrice': 'Allow editing price at sale',
    'setting.system.fields.requireCustomer': 'Require customer',
    'setting.system.fields.allowLineDiscount': 'Allow line discounts',
    'setting.system.fields.allowInvoiceDiscount': 'Allow invoice discounts',
    'setting.system.fields.autoSelectSingleProduct':
      'Auto-select product when search returns exactly one result',
    'setting.system.fields.maxPlayersPerTable': 'Maximum players per table',
    'setting.system.fields.kitchenEnabled': 'Enable kitchen',
    'setting.system.fields.locationManagementEnabled': 'Enable product location management',
    'setting.system.fields.tableOrderEnabled': 'Enable table ordering',
    'setting.system.hints.tableOrderEnabled':
      'When enabled, guests can scan the table QR and order via webview; reception must enter a reason when removing an accepted item from the bill.',
    'setting.system.fields.saleGridEnabled': 'Grid layout for regular sales',
    'setting.system.hints.saleGridEnabled':
      'When enabled, the "Regular sales" screen shows a category product grid instead of the invoice line list.',
    'setting.system.hints.locationManagementEnabled':
      'Enable inventory management by location within each branch. Selecting a location on documents remains optional.',
    'setting.system.fields.requireLocationOnSale': 'Require location selection when selling',
    'setting.system.hints.requireLocationOnSale':
      'When enabled, staff must pick a shipping location for every inventory-tracked product on the Regular sales screen. When disabled, the system auto-allocates shipping locations from available stock.',
    'setting.system.hints.autoSelectSingleProduct':
      'When enabled, product search automatically adds the product if only one result is found.',
    'setting.system.fields.allowViewCancelledInvoices': 'Allow viewing canceled invoices',
    'setting.system.hints.allowViewCancelledInvoices':
      'When off, canceled invoices are hidden from the list, and cannot be filtered or opened in detail.',
    'setting.system.fields.bankName': 'Bank name',
    'setting.system.fields.bankBin': 'VietQR BIN',
    'setting.system.fields.accountNumber': 'Account number',
    'setting.system.fields.accountHolder': 'Account holder',
    'setting.system.fields.bankBranchName': 'Bank branch',
    'setting.system.fields.isDefault': 'Default',
    'setting.system.fields.isActive': 'Status',
    'setting.system.fields.note': 'Note',
    'setting.system.fields.sortOrder': 'Sort order',
    'setting.system.actions.save': 'Save changes',
    'setting.system.actions.testSmtp': 'Send test email',
    'setting.system.actions.uploadLogo': 'Upload logo',
    'setting.system.actions.uploadFavicon': 'Upload favicon',
    'setting.system.actions.removeLogo': 'Remove logo',
    'setting.system.actions.removeFavicon': 'Remove favicon',
    'setting.system.actions.addBankAccount': 'Add bank account',
    'setting.system.actions.editBankAccount': 'Edit bank account',
    'setting.system.bank.deleteConfirm':
      'Are you sure you want to delete bank account {name} ({number})?',
    'setting.system.hints.smtpPasswordKeep': 'Leave blank to keep the current password',
    'setting.system.hints.smtpPasswordSaved': 'Password saved. Leave blank to keep it unchanged.',
    'setting.system.hints.reportRecipientEmails':
      'Enter up to 10 email addresses and press Enter after each address.',
    'setting.system.hints.timezoneFixed': 'System timezone: Asia/Ho_Chi_Minh',
    'setting.system.birthday.intro':
      'The system automatically sends birthday greeting emails at the configured time, based on stored customer and staff birthdays.',
    'setting.system.birthday.general': 'General settings',
    'setting.system.birthday.sendHour': 'Daily send time',
    'setting.system.birthday.allowCatchUp': 'Allow catch-up within the day',
    'setting.system.birthday.allowCatchUpHint':
      'When disabled, the system only sends within the exact configured hour and does not catch up past-due emails.',
    'setting.system.birthday.customerTemplate': 'Customer birthday email template',
    'setting.system.birthday.staffTemplate': 'Staff birthday email template',
    'setting.system.birthday.customerEnabled': 'Send birthday emails to customers',
    'setting.system.birthday.staffEnabled': 'Send birthday emails to staff',
    'setting.system.birthday.subject': 'Email subject',
    'setting.system.birthday.body': 'Email body',
    'setting.system.birthday.variables':
      'Supported variables: {name}, {store_name}, {birth_date}, {age}, {year}. You can write {name} or {{name}}.',
    'setting.system.birthday.defaultHint':
      'The content is rendered inside the standard system email layout. Plain text only; HTML is not rendered.',
    'setting.system.birthday.test.title': 'Send birthday email test',
    'setting.system.birthday.test.recipientType': 'Template type',
    'setting.system.birthday.test.toEmail': 'Recipient test email',
    'setting.system.birthday.test.customer': 'Customer template',
    'setting.system.birthday.test.staff': 'Staff template',
    'setting.system.birthday.test.success': 'Birthday test email sent successfully',
    'setting.system.birthday.actions.test': 'Send test',
    'setting.system.birthday.actions.history': 'View send history',
    'setting.system.birthday.history.title': 'Birthday email send history',
    'setting.system.birthday.history.subtitle':
      'Track email delivery status and verify the yearly duplicate-send prevention rules.',
    'setting.system.birthday.filters.dateFrom': 'From date',
    'setting.system.birthday.filters.dateTo': 'To date',
    'setting.system.birthday.filters.dateRange': 'Date range',
    'setting.system.birthday.filters.recipientType': 'Recipient type',
    'setting.system.birthday.filters.status': 'Status',
    'setting.system.birthday.filters.keyword': 'Search by name, email or subject',
    'setting.system.birthday.fields.recipientType': 'Recipient type',
    'setting.system.birthday.fields.recipient': 'Recipient',
    'setting.system.birthday.fields.email': 'Email',
    'setting.system.birthday.fields.birthDate': 'Birth date',
    'setting.system.birthday.fields.birthdayYear': 'Birthday year',
    'setting.system.birthday.fields.subject': 'Subject',
    'setting.system.birthday.fields.status': 'Status',
    'setting.system.birthday.fields.attempts': 'Attempts',
    'setting.system.birthday.fields.error': 'Error / skip reason',
    'setting.system.birthday.fields.sentAt': 'Sent at',
    'setting.system.birthday.fields.createdAt': 'Created at',
    'setting.system.birthday.recipient.customer': 'Customer',
    'setting.system.birthday.recipient.staff': 'Staff',
    'setting.system.birthday.status.queued': 'Queued',
    'setting.system.birthday.status.sent': 'Sent',
    'setting.system.birthday.status.failed': 'Failed',
    'setting.system.birthday.status.skipped': 'Skipped',
    'setting.system.birthday.actions.retry': 'Resend',
    'setting.system.birthday.actions.retryConfirm':
      'Resend this email? The system only allows resend when the recipient has not received this birthday email successfully in the same year.',
    'setting.system.birthday.actions.retrySuccess': 'Queued for resend',
    'setting.system.birthday.actions.resetTemplate': 'Restore default template',
    'setting.system.birthday.actions.resetTemplateConfirm':
      'Restore default subject and body templates for all customers and staff?',
    'setting.system.birthday.validation.sendHour': 'Select a valid send time (00:00 – 23:59)',
    'setting.system.birthday.validation.subject': 'Email subject is required',
    'setting.system.birthday.validation.body': 'Email body is required',
    'setting.system.birthday.duplicateHint':
      'Anti-duplicate rule: each customer or staff can receive at most one birthday email per year.',
    'setting.system.hints.brandingUiOnly':
      'Logo/favicon apply to app UI only (not print invoices yet)',
    'setting.system.hints.maxPlayersPerTable':
      'Maximum players allowed at one table (from 1 to 100)',
    'setting.system.hints.kitchenEnabled':
      'When enabled, every item must be completed or canceled before payment',
    'setting.system.hints.bankAutoBin':
      'Search by bank name or abbreviation to fill the VietQR BIN automatically',
    'setting.system.hints.bankBin': 'VietQR/NAPAS BIN contains 6 digits',
    'setting.system.validation.maxPlayersPerTable': 'Player limit must be an integer from 1 to 100',
    'setting.system.validation.bankBin': 'VietQR BIN must contain exactly 6 digits',
    'setting.system.smtpTest.title': 'Send test email',
    'setting.system.smtpTest.toEmail': 'Recipient email',
    'setting.system.smtpTest.success': 'Test email sent successfully',
    'setting.system.success.saved': 'System settings saved',
    'setting.system.errors.loadFailed': 'Failed to load system settings',
    'setting.system.errors.saveFailed': 'Failed to save system settings',
    'setting.system.errors.brandingUploadFailed': 'Failed to upload branding asset',
    'setting.system.errors.brandingDeleteFailed': 'Failed to delete branding asset',
    'setting.system.errors.smtpTestFailed': 'Failed to send test email',
    'setting.system.errors.requireCustomer': 'Please select a customer before checkout',
    'setting.system.locale.vi': 'Vietnamese',
    'setting.system.locale.en': 'English',
    'setting.system.time.24h': '24-hour',
    'setting.system.time.12h': '12-hour',
  },
}
